import { KeyDownCalendarEventPayload } from '../../schema';
import { KeyCodes } from '@fluentui/react/lib/Utilities';

export function isKeyboardCalendarEventInteractionDelete(payload: KeyDownCalendarEventPayload) {
    const event = payload?.event;

    return event && (event.keyCode == KeyCodes.del || event.keyCode == KeyCodes.backspace);
}
